import { MODEL_TEMPLATE as targeting } from "@/store/modules/targeting/defaults"

const MODEL_TEMPLATE = {
  audience: {
    _changed: false,
    id: null,
    adAccountId: null,
    audienceId: null,
    name: null,
    audienceType: null,
    audienceSubType: null,
    approximateCountLowerBound: 0,
    template: null,

    // includedAudiences: [null],
    // excludedAudiences: [],

    // subtype = lookalike
    lookalikeSpec: {
      country: null,
      origin: {
        id: null,
        name: null,
      },
      ratio: 0.01,
      startingRatio: 0,
      type: "custom_ratio",
    },
    ...targeting,
  },
}

export { MODEL_TEMPLATE }
